<template>
  <div class="heum-join">
    <div class="heum-join__title">
      {{ title }}
    </div>
    <div class="heum-join__container">
      <btn-consultation custom-class="btn btn--primary btn--large" />
    </div>
  </div>
</template>

<script>
import BtnConsultation from '@/components/common/btn-consultation.vue'

export default {
  components: { BtnConsultation },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.heum-join {
  padding: 104px 2rem 8rem;
  background: url('/images/common/bg-heum-join.jpg') no-repeat center center;
  background-size: cover;
  text-align: center;

  &__container {
    max-width: 456px;
    margin: 0 auto;
  }

  &__title {
    font-size: 32px;
    color: #393b40;
    margin-bottom: 3rem;
    line-height: 1.48;
    word-break: keep-all;
  }

  &__description {
    text-align: left;
    font-size: 13px;
    line-height: 1.48;
    color: #85878c;

    a {
      color: #85878c;
    }
  }
}
</style>
